export const PRODUCT_CATALOG_PATH = '/brand/product-catalog';

// Default number of items to show per page in the product catalog
export const DEFAULT_ITEMS_PER_PAGE = 10;
